<!-- @format -->

<section
	id="plp-srlp-bottom-pagination"
	class="bottom-pagination_container hmf-subheader-l hmf-mt-s hmf-mt-m-m hmf-mb-l hmf-ml-xs">
	@if (productListData()) {
		<div class="hmf-display-flex hmf-align-items-center hmf-justify-content-flex-end hmf-mr-xs">
			@if (pageNumber() + 1 > 1) {
				<button
					title="Previous Page"
					class="icon-container hmf-m-xxxs hmf-flex-column hmf-justify-content-center hmf-align-items-center"
					type="button"
					(click)="decreasePageNumber()">
					<homefield-icon name="chevron-left-outline"></homefield-icon>
				</button>
			}
			@if (showLeftEllipsis()) {
				<button
					hmf-action-text
					variant="sponsored"
					class="bottom-pagination-number"
					tabindex="0"
					aria-label="First Page"
					(click)="lastNumberClick(1)">
					1
				</button>
				<span class="ellipsis">...</span>
			}
			@for (displayPageNumber of displayPages(); track displayPageNumber) {
				<button
					hmf-action-text
					variant="sponsored"
					class="bottom-pagination-number"
					tabindex="0"
					[attr.aria-label]="'Page Number ' + displayPageNumber"
					[class.selected]="displayPageNumber === pageNumber() + 1"
					(click)="pageNumberCountClickEvent(displayPageNumber - 1, $index)">
					{{ displayPageNumber }}
				</button>
			}
			@if (showRightEllipsis()) {
				<span class="ellipsis">...</span>
				<button
					hmf-action-text
					variant="sponsored"
					class="bottom-pagination-number"
					tabindex="0"
					aria-label="Last Page"
					(click)="lastNumberClick(totalPages())">
					{{ totalPages() }}
				</button>
			}
			@if (pageNumber() + 1 < totalPages()) {
				<button
					title="Next Page"
					class="icon-container hmf-m-xxxs hmf-flex-column hmf-justify-content-center hmf-align-items-center"
					type="button"
					(click)="increasePageNumber()">
					<homefield-icon name="chevron-right-outline"></homefield-icon>
				</button>
			}
		</div>
	}
</section>
